import * as _ from "lodash";
import { ICrmState } from "./state";
import { ActionTypes } from "./action-types";
import { ILookupData } from ".";
import { ICrmAccountPlan, IProduct } from "../../models";

// reducer interfaces

interface ISetLookupData {
    type: string,
    lookupData: ILookupData
}

interface ISetAccountPlan {
    type: string,
    accountPlan: ICrmAccountPlan
}

interface ISetProductList {
    type: string,
    products: IProduct[]
}

interface IUpdateCenterNotes {
    type: string,
    notes: string
}

interface ISetProductIsActive {
    type: string,
    productId: number,
    isActive: boolean
}

// reducer functions

const setLookupData = (state: ICrmState, action: ISetLookupData) => {
    state.productList = action.lookupData.products;
    state.staffList = action.lookupData.staff;
    return state;
}

const setAccountPlan = (state: ICrmState, action: ISetAccountPlan) => {
    state.accountPlan = action.accountPlan;
    return state;
}

const setProductList = (state: ICrmState, action: ISetProductList) => {
    state.productList = action.products;
    return state;
}

const updateCenterNotes = (state: ICrmState, action: IUpdateCenterNotes) => {
    state.accountPlan.notes = action.notes;
    return state;
}

const setProductIsActive = (state: ICrmState, action: ISetProductIsActive) => {
    state.productList = state.productList.map(item => {
        if (item.id == action.productId) {
            item.isActive = action.isActive;
        }

        return item;
    })

    return state;
}

// reducer creation

var initialState: ICrmState = {
    productList: [],
    staffList: [],
    accountPlan: null
}

const createReducer = (initialState: ICrmState, handlers: any) => {
    return function reducer(state = initialState, action: any) {
        if (handlers.hasOwnProperty(action.type)) {
            let s = _.cloneDeep(state);
            return handlers[action.type](s, action);
        } else {
            return state;
        }
    }
}

const handlers = {
    [ActionTypes.SET_CRM_LOOKUP_DATA]: setLookupData,
    [ActionTypes.SET_CRM_ACCOUNT_PLAN]: setAccountPlan,
    [ActionTypes.SET_CRM_PRODUCT_LIST]: setProductList,
    [ActionTypes.UPDATE_CENTER_NOTES]: updateCenterNotes,
    [ActionTypes.SET_PRODUCT_IS_ACTIVE]: setProductIsActive
}

export const Reducer = createReducer(initialState, handlers);